import React, { Component } from 'react'
import '../static/css/hbbmodal.css'

class HBBModal extends Component {
    render() {
        return (
            <div className="hbb-modal">
                <div className="hbb-modal-background">
                    <div className="hbb-modal-layout">
                        {this.props.children}
                    </div>
                </div>
            </div>
        )
    }
}

export default HBBModal


// WEBPACK FOOTER //
// ./src/modules/Modal/Components/HBBModal.js